
import { AUTH_CONFIG } from '../Auth/auth0-variables';
import axios from 'axios';
import moment from 'moment';


export const RECEIVE_REQUESTCOUNT = 'RECEIVE_REQUESTCOUNT'
export const REQUEST_REQUESTCOUNT = 'REQUEST_REQUESTCOUNT'

export const FILTER_AUDITS = 'FILTER_AUDITS'
export const START_DATE = 'START_DATE'
export const SHOW_TOAST = 'SHOW_TOAST'
export const END_DATE = 'END_DATE'
export const UPDATE_APPSTATE = 'UPDATE_APPSTATE'
export const UPDATE_USER = 'UPDATE_USER'
export const UPDATE_USER_PROFILE = 'UPDATE_USER_PROFILE';
export const SET_APP_STATE = 'SET_APP_STATE';
export const UPDATE_SCHEDULEDATE = 'UPDATE_SCHEDULEDATE'
export const UPDATE_SCHEDULECLEAR = 'UPDATE_SCHEDULECLEAR'
export const REQUEST_SHIFTS = 'REQUEST_SHIFTS'
export const RECEIVE_SHIFTS = 'RECEIVE_SHIFTS'
export const REQUEST_WEATHER = 'REQUEST_WEATHER'
export const RECEIVE_WEATHER = 'RECEIVE_WEATHER'
export const REQUEST_SCHEDULE = 'REQUEST_SCHEDULE'
export const RECEIVE_SCHEDULE = 'RECEIVE_SCHEDULE'
export const SELECT_AUDIT = 'SELECT_AUDIT'
export const VISIT_NUMBER = 'VISIT_NUMBER'
export const FILTERED_SHIFT = 'FILTERED_SHIFT'
export const FILTERED_EMPLOYEE = "FILTERED_EMPLOYEE"
export const FILTERED_ROLE = "FILTERED_ROLE"
export const CLEARING_SCHEDULE = "CLEARING_SCHEDULE"
export const REFRESH_SCHEDULE = "REFRESH_SCHEDULE"
export const SET_PROFILEPAGE = "SET_PROFILEPAGE"
export const SCHEDULECONFLICTS = "SCHEDULECONFLICTS"
export const SCHEDULECONFLICTSONLY = "SCHEDULECONFLICTSONLY"
export const CLOSENAV = "CLOSENAV"
export const CLOSECHAT = "CLOSECHAT"
export const CHATUSERID = "CHATUSERID"
export const THEME = "THEME"
export const UPDATE_FETCHING = "UPDATE_FETCHING"
export const SELECT_AUDITUSER = 'SELECT_AUDITUSER'
// Request count

function requestRequestCount() {
    return {
        type: REQUEST_REQUESTCOUNT
    }
}
function receiveRequestCount(response, state) {
    return {
        type: RECEIVE_REQUESTCOUNT,
        count: response
    }
}
function fetchRequestCount(state) {
    return (dispatch, getState) => {
        dispatch(requestRequestCount());
        axios.get(AUTH_CONFIG.API_URL + "/api/GetShiftRequestCount?facilityId=" + state.appState.product.facility.facilityID)
            .then((response) => {
                dispatch(receiveRequestCount(response.data[0], getState()))
            });
    }
}
export function fetchRequestCountIfNeeded() {
    return (dispatch, getState) => {
        return dispatch(fetchRequestCount(getState()))
    }
}

// End Request count




export function fetching(f) {
    return {
        type: UPDATE_FETCHING,
        fetching: f
    }
}

// shifts

function receiveShifts(response) {
    return {
        type: RECEIVE_SHIFTS,
        shifts: response
    }
}
function fetchShifts(state, date, facilityId) {
    return (dispatch) => {

      

        //dispatch(requestShifts());
        //dispatch(fetching(true))
        let scheduleDate = date ? date : state.rootReducer.scheduleDate;
        let from = (!state.rootReducer.shifts.selectShiftsFrom ? 'null' : moment(state.rootReducer.shifts.selectShiftsFrom).format('YYYY-MM-DD'));
        let url = ""
        
        url = "/api/Schedules/GetEmployeeScheduleSummary?facilityId=" + facilityId + "&selectShiftsFrom=" + from + "&selectedDate=" + moment(scheduleDate).format('YYYY-MM-DD');

        axios.get(AUTH_CONFIG.API_URL + url)
            .then((response) => {
                dispatch(receiveShifts(response.data))
            });
    }
}

function shouldFetchShifts(state) {
    if (state.rootReducer.shifts.shifts.length < 1 && !state.rootReducer.shifts.shifts.isFetchingShifts) {
        return true;
    } else if (state.rootReducer.shifts.shifts.length > 0) {
        return false;
    }
}

export function fetchShiftsIfNeeded(reload, date, facilityId) {
    return (dispatch, getState) => {
        if (shouldFetchShifts(getState()) || reload) {
            return dispatch(fetchShifts(getState(), date, facilityId))
        }
    }
}

export function manuallyUpdateShifts(data) {
    return (dispatch, getState) => {
        dispatch(receiveShifts(data, getState()))
    }
}

// End Shifts

// weather icons

function requestWeather() {
    return {
        type: REQUEST_WEATHER
    }
}
function receiveWeather(response, state) {
    return {
        type: RECEIVE_WEATHER,
        weather: response
    }
}
function fetchWeather(state) {
    return (dispatch, getState) => {
        dispatch(requestWeather());
       
        axios.get(AUTH_CONFIG.API_URL + "/api/Schedules/GetWeatherIcons?facilityId=" + state.appState.product.facility.facilityID)
            .then((response) => {
                dispatch(receiveWeather(response.data, getState()))
            });
    }
}
function shouldFetchWeather(state) {
    if (state.rootReducer.weather.weather.length < 1) {
        return true;
    } else if (state.rootReducer.weather.weather.length > 0) {
        return false;
    }
}

export function fetchWeatherIfNeeded(reload) {
    return (dispatch, getState) => {
        if (shouldFetchWeather(getState()) || reload) {
            return dispatch(fetchWeather(getState()))
        }
    }
}

// End weather icons

export function startDate(startdate) {
    return {
        type: START_DATE,
        startdate
    }
}

export function showToast(showToast) {
    return {
        type: SHOW_TOAST,
        showToast
    }
}

export function endDate(enddate) {
    return {
        type: END_DATE,
        enddate
    }
}

export function updateUser(newUser) {
    return {
        type: UPDATE_USER,
        user: newUser
    }
}


export function setAppState(appState) {
    return {
        type: SET_APP_STATE,
        appState: appState
    }
}

export function recordPromoImpression(cardKey) {
    return (dispatch, getState) => {
        var state = getState();
        var appState = state.appState || {};
        var promoState = Array.isArray(appState.promoState) ? appState.promoState.slice() : [];
        var idx = promoState.findIndex(function (p) { return p.cardKey === cardKey; });
        var now = new Date().toISOString();
        if (idx === -1) {
            promoState.push({ cardKey: cardKey, dismissed: false, seenCount: 1, firstSeenOn: now });
        } else {
            var existing = promoState[idx];
            promoState[idx] = Object.assign({}, existing, {
                seenCount: (existing.seenCount || 0) + 1,
                firstSeenOn: existing.firstSeenOn || now
            });
        }
        dispatch(setAppState(Object.assign({}, appState, { promoState: promoState })));

        axios.post(AUTH_CONFIG.API_URL + "/api/Account/RecordPromoImpression", { cardKey: cardKey })
            .catch(function () { /* impression tracking is best-effort */ });
    }
}

export function dismissPromo(cardKey) {
    return (dispatch, getState) => {
        var state = getState();
        var appState = state.appState || {};
        var promoState = Array.isArray(appState.promoState) ? appState.promoState.slice() : [];
        var idx = promoState.findIndex(function (p) { return p.cardKey === cardKey; });
        if (idx === -1) {
            promoState.push({ cardKey: cardKey, dismissed: true, seenCount: 0, firstSeenOn: null });
        } else {
            promoState[idx] = Object.assign({}, promoState[idx], { dismissed: true });
        }
        dispatch(setAppState(Object.assign({}, appState, { promoState: promoState })));

        axios.post(AUTH_CONFIG.API_URL + "/api/Account/DismissPromo", { cardKey: cardKey })
            .catch(function () { /* dismissal is best-effort */ });
    }
}

export function updateAppStateEmployees(appState) {
    
    return (dispatch, getState) => {
        var state = getState();
        
        axios.get(AUTH_CONFIG.API_URL + "/api/Account/GetEmployeesByFacility?facilityId=" + state.appState.product.facility.facilityID)
            .then((response) => {
                state.appState.product.facility.employees = response.data;
                dispatch(setAppState(state.appState))
            });
    }
    return {
        type: SET_APP_STATE,
        appState: appState
    }
}

export function updateAppStateRoles(appState) {

    return (dispatch, getState) => {
        var state = getState();

        axios.get(AUTH_CONFIG.API_URL + "/api/Helper/GetRolesAppState?facilityId=" + state.appState.product.facility.facilityID)
            .then((response) => {
                state.appState.product.facility.facilityRoles = response.data.roles;
                state.appState.product.availableFacilities = response.data.productFacilities;
                dispatch(setAppState(state.appState))
            });
    }
    return {
        type: SET_APP_STATE,
        appState: appState
    }
}

export function updateScheduleDate(date) {
    var store = window.store;
    var state = store.getState();
    if (date < moment(state.rootReducer.shifts.selectShiftsFrom).toDate()) {
        store.dispatch(fetchShiftsIfNeeded(true, date))
    }
    
    return {
        type: UPDATE_SCHEDULEDATE,
        scheduleDate: date
    }
}

export function profilePage(x) {
    return {
        type: SET_PROFILEPAGE,
        profilePage: x
    }
}

export function refreshSchedule(x) {
    return {
        type: REFRESH_SCHEDULE,
        refreshSchedule: x
    }
}

export function clearingScheduler(x) {
    return {
        type: CLEARING_SCHEDULE,
        clearingSchedule: x
    }
}

export function updateScheduleClear(date) {
    return {
        type: UPDATE_SCHEDULECLEAR,
        scheduleClear: date
    }
}

export function scheduleConflictsOnly(x) {
    return {
        type: SCHEDULECONFLICTSONLY,
        scheduleConflictsOnly: x
    }
}

export function scheduleConflicts(x) {
    return {
        type: SCHEDULECONFLICTS,
        scheduleConflicts: x
    }
}

export function toggleNav(x) {
    return {
        type: CLOSENAV,
        closeNav: x
    }
}

export function closeChat(x) {
    return {
        type: CLOSECHAT,
        closeChat: x
    }
}

export function chatUserId(x) {
    return {
        type: CHATUSERID,
        chatUserId: x
    }
}

export function toggleTheme(x) {
    return {
        type: THEME,
        theme: x
    }
}

export function updateFilteredShift(id) {
    return {
        type: FILTERED_SHIFT,
        filteredShift: id
    }
}

export function updateFilteredRole(id) {
    return {
        type: FILTERED_ROLE,
        filteredRole: id
    }
}

export function updateFilteredEmployee(id) {
    return {
        type: FILTERED_EMPLOYEE,
        filteredEmployee: id
    }
}

export default function updateState(state = '', { type, payload }) {
    switch (type) {
        case UPDATE_APPSTATE:
            return payload.user;
        default:
            return state;
    }
    return state;
}

export function updateUserProfile(user) {
    return {
        type: UPDATE_USER_PROFILE,
        userProfile: user
    }
}